import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { AddTicket } from "../../services/ticket/ticket";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Ticket() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [title, setTitle] = useState("");
  const [priority, setPriority] = useState("");
  const [description, setDescription] = useState("");
  const [attachment, setAttachment] = useState(null);
  const [loading, setLoading] = useState(false);

  const maxSizeMB = 30;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > maxSizeMB * 1024 * 1024) {
      alert(t("Support.30mb"));
      e.target.value = "";
      return;
    }

    setAttachment(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);

    const formData = new FormData();
    formData.append("idUser", Number(0)); // Replace with real user ID
    formData.append("title", title);
    formData.append("type", Number(priority));
    formData.append("comment", description);
    formData.append("file", attachment || "");
    formData.append("pathfile", "");

    try {
      await AddTicket(formData);
      navigate("/support");
    } catch (error) {
      console.error("Error submitting ticket:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 4 }}>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          backgroundColor: "#F4F2FB",
          p: 3,
          borderRadius: 3,
          display: "flex",
          flexDirection: "column",
          width: "100%",
          maxWidth: "600px",
          gap: 2,
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          {t("Support.Ticket")}
        </Typography>

        <TextField
          required
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          label={t("Support.Title")}
          fullWidth
        />

        <FormControl fullWidth required>
          <InputLabel id="priority-label">{t("Support.Severity")}</InputLabel>
          <Select
            labelId="priority-label"
            value={priority}
            label={t("Support.Severity")}
            onChange={(e) => setPriority(e.target.value)}
          >
            <MenuItem value={4}>{t("Support.Low")}</MenuItem>
            <MenuItem value={3}>{t("Support.Moderate")}</MenuItem>
            <MenuItem value={2}>{t("Support.Urgent")}</MenuItem>
            <MenuItem value={1}>{t("Support.Critical")}</MenuItem>
          </Select>
        </FormControl>

        <TextField
          required
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          label={t("Support.Text")}
          multiline
          rows={5}
        />

        <Button
          variant="outlined"
          component="label"
          sx={{ alignSelf: "flex-start" }}
          endIcon={<AttachFileIcon />}
          disabled={loading}
        >
          {t("Support.Attach")}
          <input type="file" hidden onChange={handleFileChange} />
        </Button>

        {attachment && (
          <Typography variant="body2" color="text.secondary">
            {attachment.name}
          </Typography>
        )}

        <Button
          type="submit"
          variant="contained"
          color="secondary"
          disabled={loading}
          sx={{ borderRadius: "100px", py: 1.2, fontSize: "16px", mt: 2 }}
        >
          {loading ? (
            <>
              <CircularProgress size={20} sx={{ mr: 1 }} />
              {t("Support.Send")}
            </>
          ) : (
            t("Support.Send")
          )}
        </Button>
      </Box>
    </Box>
  );
}

export default Ticket;
